import * as api from './api/api';
import config from '../config/api'
import { axiosInstance } from '../api/axiosIntance';

export class ApiClient {
  authApi: api.AuthApi;
  healthApi: api.HealthApi;
  organizationsApi: api.OrganizationsApi;
  plansApi: api.PlansApi;
  subscriptionsApi: api.SubscriptionsApi;
  usersApi: api.UsersApi;
  customerApi: api.CustomersApi;
  driversApi: api.DriversApi;
  loadsApi: api.LoadsApi;
  loadTemplatesApi: api.LoadTemplatesApi;
  documentsApi: api.DocumentsApi;
  recurringLoadsApi: api.RecurringLoadsApi;
  trucksApi: api.TrucksApi;
  trailersApi: api.TrailersApi;
  carriersApi: api.CarriersApi;
  maintenanceApi: api.MaintenanceApi;
  workOrdersApi: api.WorkOrdersApi;
  inspectionsApi: api.InspectionsApi;
  fleetApi: api.FleetApi;
  truckMaintenanceApi: api.TruckMaintenanceApi;
  trailerMaintenanceApi: api.TrailerMaintenanceApi;
  quotesApi: api.QuotesApi;
  samsaraApi: api.SamsaraApi;
  samsaraCallbackApi: api.SamsaraCallbackApi;
  invoicesApi: api.InvoicesApi;
  // paymentsApi: api.PaymentsApi;
  settlementsApi: api.SettlementsApi;
  driverSettlementsApi: api.DriverSettlementsApi;
  expensesApi: api.ExpensesApi;
  reportsApi: api.ReportsApi;
  // collectionsApi: api.CollectionsApi;
  fuelApi: api.FuelApi;
  quickbooksApi: api.QuickBooksApi;
  quickbooksCallbackApi: api.QuickBooksCallbackApi;
  qbMappingsApi: api.QBMappingsApi;
  qbCachedAccountsApi: api.QBCachedAccountsApi;
  loadCalculatorApi: api.LoadCalculatorApi;
  relayApi: api.RelayApi;
  mileageApi: api.MileageApi;
  documentParseApi: api.DocumentParseApi;
  accountingApi: api.AccountingApi;
  paystubsApi: api.PaystubsApi;
  fleetrockApi: api.FleetrockApi;
  vmrsApi: api.VMRSApi;
  partsApi: api.PartsApi;
  maintenanceFleetApi: api.MaintenanceFleetApi;
  truckMaintenanceDetailApi: api.TruckMaintenanceDetailApi;
  trailerMaintenanceDetailApi: api.TrailerMaintenanceDetailApi;
  techniciansApi: api.TechniciansApi;
  inspectionDefectWOApi: api.InspectionDefectWOApi;
  constructor() {
    this.authApi = new api.AuthApi(undefined, config.API_BASE_URL, axiosInstance);
    this.healthApi = new api.HealthApi(undefined, config.API_BASE_URL, axiosInstance);
    this.organizationsApi = new api.OrganizationsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.plansApi = new api.PlansApi(undefined, config.API_BASE_URL, axiosInstance);
    this.subscriptionsApi = new api.SubscriptionsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.usersApi = new api.UsersApi(undefined, config.API_BASE_URL, axiosInstance);
    this.customerApi = new api.CustomersApi(undefined, config.API_BASE_URL, axiosInstance)
    this.driversApi = new api.DriversApi(undefined, config.API_BASE_URL, axiosInstance)
    this.loadsApi = new api.LoadsApi(undefined, config.API_BASE_URL, axiosInstance)
    this.loadTemplatesApi = new api.LoadTemplatesApi(undefined, config.API_BASE_URL, axiosInstance)
    this.documentsApi = new api.DocumentsApi(undefined, config.API_BASE_URL, axiosInstance)
    this.recurringLoadsApi = new api.RecurringLoadsApi(undefined, config.API_BASE_URL, axiosInstance)
    this.trucksApi = new api.TrucksApi(undefined, config.API_BASE_URL, axiosInstance)
    this.trailersApi = new api.TrailersApi(undefined, config.API_BASE_URL, axiosInstance)
    this.carriersApi = new api.CarriersApi(undefined, config.API_BASE_URL, axiosInstance)
    this.maintenanceApi = new api.MaintenanceApi(undefined, config.API_BASE_URL, axiosInstance)
    this.workOrdersApi = new api.WorkOrdersApi(undefined, config.API_BASE_URL, axiosInstance)
    this.inspectionsApi = new api.InspectionsApi(undefined, config.API_BASE_URL, axiosInstance)
    this.fleetApi = new api.FleetApi(undefined, config.API_BASE_URL, axiosInstance);
    this.truckMaintenanceApi = new api.TruckMaintenanceApi(undefined, config.API_BASE_URL, axiosInstance);
    this.trailerMaintenanceApi = new api.TrailerMaintenanceApi(undefined, config.API_BASE_URL, axiosInstance);
    this.quotesApi = new api.QuotesApi(undefined, config.API_BASE_URL, axiosInstance);
    this.samsaraApi = new api.SamsaraApi(undefined, config.API_BASE_URL, axiosInstance);
    this.samsaraCallbackApi = new api.SamsaraCallbackApi(undefined, config.API_BASE_URL, axiosInstance);
    this.invoicesApi = new api.InvoicesApi(undefined, config.API_BASE_URL, axiosInstance);
    // this.paymentsApi = new api.PaymentsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.settlementsApi = new api.SettlementsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.driverSettlementsApi = new api.DriverSettlementsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.expensesApi = new api.ExpensesApi(undefined, config.API_BASE_URL, axiosInstance);
    this.reportsApi = new api.ReportsApi(undefined, config.API_BASE_URL, axiosInstance);
    // this.collectionsApi = new api.CollectionsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.fuelApi = new api.FuelApi(undefined, config.API_BASE_URL, axiosInstance);
    this.quickbooksApi = new api.QuickBooksApi(undefined, config.API_BASE_URL, axiosInstance);
    this.quickbooksCallbackApi = new api.QuickBooksCallbackApi(undefined, config.API_BASE_URL, axiosInstance);
    this.qbMappingsApi = new api.QBMappingsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.qbCachedAccountsApi = new api.QBCachedAccountsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.loadCalculatorApi = new api.LoadCalculatorApi(undefined, config.API_BASE_URL, axiosInstance);
    this.relayApi = new api.RelayApi(undefined, config.API_BASE_URL, axiosInstance);
    this.mileageApi = new api.MileageApi(undefined, config.API_BASE_URL, axiosInstance);
    this.documentParseApi = new api.DocumentParseApi(undefined, config.API_BASE_URL, axiosInstance);
    this.accountingApi = new api.AccountingApi(undefined, config.API_BASE_URL, axiosInstance);
    this.paystubsApi = new api.PaystubsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.fleetrockApi = new api.FleetrockApi(undefined, config.API_BASE_URL, axiosInstance);
    this.vmrsApi = new api.VMRSApi(undefined, config.API_BASE_URL, axiosInstance);
    this.partsApi = new api.PartsApi(undefined, config.API_BASE_URL, axiosInstance);
    this.maintenanceFleetApi = new api.MaintenanceFleetApi(undefined, config.API_BASE_URL, axiosInstance);
    this.truckMaintenanceDetailApi = new api.TruckMaintenanceDetailApi(undefined, config.API_BASE_URL, axiosInstance);
    this.trailerMaintenanceDetailApi = new api.TrailerMaintenanceDetailApi(undefined, config.API_BASE_URL, axiosInstance);
    this.techniciansApi = new api.TechniciansApi(undefined, config.API_BASE_URL, axiosInstance);
    this.inspectionDefectWOApi = new api.InspectionDefectWOApi(undefined, config.API_BASE_URL, axiosInstance);
  }
}

export const apiClient = new ApiClient();

export { api as API };